import { useEffect, useState } from 'react';
import moment from 'moment';
import { useGetUserAgendaMutation } from 'services/agenda/agenda.endpoint';
import { AgendaEvent } from 'services/agenda/agenda.types';

export default function useAgendaVM() {
    const [events, setEvents] = useState<Array<AgendaEvent>>([]);
    const [futureEvent, setFutureEvent] = useState<AgendaEvent | null>(null);
    const [selectedEvent, setSelectedEvent] = useState<AgendaEvent | null>(null);

    function formatDate(date: string) {
        return moment(date).format('DD MMMM YYYY');
    }

    function formatHour(date: string) {
        return moment(date).format('HH:mm');
    }

    const [
        getUserAgenda,
        {
            isLoading: isUserAgendaLoading,
            isError: isUserAgendaError,
            isSuccess: isUserAgendaSuccess,
            error: UserAgendaError,
            data: UserAgendaResponse
        }
    ] = useGetUserAgendaMutation();

    useEffect(() => {
        getUserAgenda(undefined);
    }, []);

    useEffect(() => {
        setSelectedEvent(events.at(-1) || null);
    }, [events]);

    useEffect(() => {
        if (isUserAgendaLoading) return;
        if (isUserAgendaError && UserAgendaError) {
            return;
        }
        if (isUserAgendaSuccess && UserAgendaResponse) {
            const today = moment().startOf('day');

            const pastEvents = UserAgendaResponse.data
                .filter((event) => moment(event.started_at).startOf('day').isBefore(today))
                .sort((a, b) => moment(b.started_at).valueOf() - moment(a.started_at).valueOf());

            const futureEvent = UserAgendaResponse.data
                .filter((event) => moment(event.started_at).startOf('day').isSameOrAfter(today))
                .sort((a, b) => moment(a.started_at).valueOf() - moment(b.started_at).valueOf())
                .slice(0, 1);

            setEvents(pastEvents);
            setFutureEvent(futureEvent.at(0) || null);
        }
    }, [isUserAgendaLoading, isUserAgendaError, isUserAgendaSuccess, UserAgendaError, UserAgendaResponse]);

    return {
        events,
        futureEvent,
        formatDate,
        formatHour,
        selectedEvent,
        setSelectedEvent,
        isApiRequestLoading: isUserAgendaLoading,
    };
}
